import React, {Component} from 'react';
import Dropzone from 'react-dropzone'
import {Segment, Icon, Button, Label, Table, Embed, Loader, Step} from 'semantic-ui-react';

class Designation extends Component {

  /***** Page Functions *****/
  constructor(props) {
    super(props);
    //console.log(this.props)
    this.steps = [
      {key:1, icon:"info", description:"Review properties"},
      {key:2, icon:"attach", description:"Attach document"},
      {key:3, icon:"edit", description:"Validate Submission"},
      {key:4, icon:"print", description:"Preview Submission"},
      {key:5, icon:"send", description:"Submit"},
    ];

    const todaysDate = new Date()
    //getmonth and getday return a zero based value, i.e. January is 0
    const createDate = todaysDate.getFullYear() + "-" +
      this.zeroFill(todaysDate.getMonth() + 1, 2) + "-" +
      this.zeroFill(todaysDate.getDate(), 2)

    this.state = {
      pageNum: 1,
      lpNumber: null,
      todaysDate: todaysDate,
      createDate: createDate,
      results: [],
      validAddress: [],
      filesToBeSent: [],
      acrisDocument: null,
      dispReady: false,
      submissionComplete: false,
      acrisError: null,
      errorOnPage: false,
      User: this.props.User
    };
  }

  componentDidMount() {
    this.getDesignationDetails()
  }

  render() {
    var componentToShow;

    switch (this.state.pageNum) {
      case 1 :
        componentToShow = this.renderAddresses()
        break;
      case 2 :
        componentToShow = this.renderUploadFiles()
        break;
      case 3 :
        componentToShow = this.renderDOFStep1()
        break;
      case 4 :
        componentToShow = this.renderDOFStep2()
        break;
      case 5 :
        componentToShow = this.renderDOFStep3()
        break;
      default :
        componentToShow = this.renderAddresses()
        break;
    }
//
    return (
      <div className="Designation">
        <Segment raised>
          {this.renderDetail()}
          {this.renderSteps()}
          {componentToShow}
          <br />
          {this.renderButtons()}
        </Segment>
      </div>
    )
  }

  /********************************/
  /* Buttons                      */
  /********************************/

  /***** Renderer ****/
  renderButtons() {

    return (
      <div>
        <table width="100%">
          <tbody>
          <tr>
            <td>
              <Button color='red' disabled={this.state.pageNum===5}
                      onClick={this.handleButtonClick.bind(this, 0)}>
                Cancel
              </Button>
            </td>
            <td align="right">
              <Button icon labelPosition='left' disabled={this.state.pageNum===1 || this.state.pageNum===5}
                      onClick={this.handleButtonClick.bind(this, -1)}>
                Previous
                <Icon name='left arrow'/>
              </Button>
              <Button icon labelPosition='right' disabled={this.state.pageNum===5}
                      onClick={this.handleButtonClick.bind(this, +1)}>
                Next
                <Icon name='right arrow'/>
              </Button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    )
  }

  /***** Event Handler ****/
  handleButtonClick(nextorprev) {
    if(this.state.errorOnPage) {
      alert("Please review submission for errors before proceeding.")
      return
    }
    if (nextorprev === 0)
      this.props.handleReturnToList()
    if (this.state.pageNum === 2 && nextorprev === 1) {
      //load Acris Document
      this.createDocumentID()
    }
    if (this.state.pageNum === 3 && nextorprev === 1) {
      if(this.state.acrisError) {
        alert("Unable to proceed further. Please correct the errors in your data before proceeding.")
        return
      }
      else
        //Upload Documents to ACRIS
        this.uploadDocumentsToAcris()
    }
    if (this.state.pageNum === 4 && nextorprev === 1) {
      //Submit to ACRIS
      this.submitToAcris()
    }
    this.setState({pageNum: this.state.pageNum + nextorprev})
  }

  renderSteps() {
    var curPageNum = this.state.pageNum
    var _steps = this.steps.map(function (aStep) {
      const _active = aStep.key===curPageNum
      return(
        <Step active={_active} key={aStep.key}>
          <Icon name={aStep.icon} />
          <Step.Content>
            <Step.Title>STEP {aStep.key}</Step.Title>
            <Step.Description>{aStep.description}</Step.Description>
          </Step.Content>
        </Step>
      )
    })

    return (
      <Step.Group size="tiny" fluid>
        {_steps}
      </Step.Group>
    )
  }

  /********************************/
  /* Designation Details          */
  /********************************/

  /***** Renderer ****/
  renderDetail() {
    const results = this.state.results
    //OBJECTID, LP_NUMBER, BBL, LM_NAME, DESIG_ADDRESS,DESIG_DATE,LM_TYPE
    if (results.length === 0)
      return

    return (
      <div>
        <Label as='a' color='blue' ribbon>
          Designation Details
        </Label>
        <table width="100%">
          <tbody>
          <tr>
            <td><b>LP Number</b><br />{results[0]["LP_NUMBER"]}</td>
            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
            <td><b>Landmark Name</b><br />{results[0]["LM_NAME"]}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td><b>Designation Date</b><br />
              {results[0]["DESIG_DATESTR"]}</td>
            <td>&nbsp;&nbsp;</td>
            <td><b>Designation Type</b><br />{results[0]["LM_TYPE"]}</td>
            <td><b>Number of Blocks & Lots & Units</b><br />{results.length}</td>
            <td align="right">
              <Button content='Review Notice'
                      icon='file pdf outline' labelPosition='left'
                      size="small" color="blue"
                      disabled={this.state.pageNum>1}
                      onClick={this.handleOpenReport}
              />
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    )
  }

  /********************************/
  /* Addresses                    */
  /********************************/

  /***** Renderer ****/
  renderAddresses() {
    var docPlaceholder
    if (this.state.dispReady)
      docPlaceholder = this.renderAddressesTable()
    else
      docPlaceholder = <Loader active inline='centered'/>
    return (
      <div>
        <div className="properties-list">
          {docPlaceholder}
        </div>
      </div>
    )
  }

  renderAddressesTable () {
    const results = this.state.results;
    var invalidAddressFlag = false;
    var retval = results.map(function (tblRow, rowNum) {
      var errorRow = false
      if(tblRow["VALIDATED_ADDR"]!=="") {
        errorRow = true
        invalidAddressFlag = true;
      }
      return(
        <Table.Row key={tblRow["OBJECTID"]} error={errorRow}>
          <Table.Cell>{rowNum+1}</Table.Cell>
          <Table.Cell>{tblRow["BBL_BOROSTR"]} ({tblRow["BBL_BORO"]})</Table.Cell>
          <Table.Cell>{tblRow["BBL_BLOCK"]}</Table.Cell>
          <Table.Cell>{tblRow["BBL_LOT"]}</Table.Cell>
          <Table.Cell>{tblRow["DESIG_ADDRESS"]}</Table.Cell>
          <Table.Cell>{tblRow["STREET_NUM"]}</Table.Cell>
          <Table.Cell>{tblRow["STREET_NAME"]}</Table.Cell>
          <Table.Cell>{tblRow["UNIT_NUM"]}</Table.Cell>
          <Table.Cell>{tblRow["VALIDATED_ADDR"]}</Table.Cell>
        </Table.Row>
      )
    })
    return (
      <div>
        <div className="properties-list">
          <Table celled striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>#</Table.HeaderCell>
                <Table.HeaderCell>Borough</Table.HeaderCell>
                <Table.HeaderCell>Block</Table.HeaderCell>
                <Table.HeaderCell>Lot</Table.HeaderCell>
                <Table.HeaderCell>Address</Table.HeaderCell>
                <Table.HeaderCell>Street Number</Table.HeaderCell>
                <Table.HeaderCell>Street Name</Table.HeaderCell>
                <Table.HeaderCell>Unit Number</Table.HeaderCell>
                <Table.HeaderCell>Validated Address</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {retval}
            </Table.Body>
          </Table>
        </div>
      </div>
    )
  }

  /***** Event Handling *****/
  handleOpenReport = () => window.open(window.letterServerURL + this.state.results[0]["LP_NUMBER"] + ".pdf",
    '_blank', 'fullscreen=yes')


  /***** Data Handling ****/
  getDesignationDetails() {
    this.setState({dispReady : false })
    const url = window.globalAppTrackURL + "LP/" + this.props.lpNumber;
    //console.log(url)
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.finishGettingDetails(json)
      );
  }

  finishGettingDetails(json) {
    // console.log(json)
    // var retval = json.map(function (tblRow) {
    //   //console.log(tblRow)
    //   this.validateAddress(tblRow)
    // })
    this.setState({results: json});

    /***** Generate Letter *****/
    const url = window.globalAppTrackURL + "LR/" + this.props.lpNumber;
    fetch(url).then(function (response) {
      return response.json();
    })
      .then(
        (json) => this.showLetter(json)
      );

    this.setState({dispReady : true })
  }

  showLetter(json) {

  }

  //validateAddress(argData) {return {apple:1}}
  validateAddress(argData) {
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": this.state.User,
        "addressData": argData,
      }
    }
    rp({
        url: window.globalAppTrackURL + "ValidateAddress",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

      .then((json) => this.finishValidating(json))
    return {apple:1}
  }

  finishValidating(res) {
    console.log(res)
  }

  /********************************/
  /* Upload Files                 */
  /********************************/

  /***** Renderer ****/
  renderUploadFiles() {
    var filesToBeSent = this.state.filesToBeSent;
    var tblRows = [];

    for (var i = 0; i < filesToBeSent.length; i++) {
      tblRows.push(
        <Table.Row key={i}>
          <Table.Cell>
            <Button icon onClick={this.handleDeleteClick.bind(this, i)}><Icon name='delete'/></Button>
          </Table.Cell>
          <Table.Cell>
            <a href={filesToBeSent[i]["preview"]} target="new">
              {filesToBeSent[i]["name"]}
            </a>
          </Table.Cell>
          <Table.Cell>{filesToBeSent[i]["lastModifiedDate"].toDateString()}</Table.Cell>
          <Table.Cell>{filesToBeSent[i]["size"]}</Table.Cell>
          <Table.Cell>{filesToBeSent[i]["numpages"]}</Table.Cell>
        </Table.Row>
      )
    }

    return (
      <div>
        <table width="100%">
          <tbody>
          <tr>
            <td valign="top" align="left">
              <Dropzone onDrop={(files) => this.onDrop(files)} accept="application/pdf">
                <div>
                  Drop LPC notice of designation file here (notarized).<br /><br />
                  (please note, only PDF files are acceptable)
                  <br />
                </div>
              </Dropzone>
            </td>
            <td valign="top" align="left">
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>&nbsp;</Table.HeaderCell>
                    <Table.HeaderCell>File Name</Table.HeaderCell>
                    <Table.HeaderCell>File Date</Table.HeaderCell>
                    <Table.HeaderCell>File Size</Table.HeaderCell>
                    <Table.HeaderCell>Number of Pages</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {tblRows}
                </Table.Body>
              </Table>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    )
  }

  /***** Event Handlers ****/
  handleDeleteClick(rowNo) {
    var filesToBeSent = this.state.filesToBeSent;
    this.deleteFile(filesToBeSent[rowNo])
    filesToBeSent.splice([rowNo], 1);
    this.setState({filesToBeSent});
  }

  onDrop(acceptedFiles, rejectedFiles) {
    for (var i = 0; i < acceptedFiles.length; i++) {
      this.uploadFile(acceptedFiles[i])
    }
  }

  uploadFile(argFile) {
    const results = this.state.results
    var Promise = this.Promise || require('promise');
    const request = require('superagent-promise')(require('superagent'), Promise);
    const req = request.post(window.globalAppTrackURL + "UploadFile/" + results[0]["LP_NUMBER"])
    req.attach("file", argFile)
    req.end()
      .then(function(res)  {return(res)})
      .catch(function(err) {return(err)})

    .then((json) => this.finishUpload(argFile, json))
  }

  finishUpload(argFile, res) {
    argFile.numpages = res.body.NumPages
    const joined = this.state.filesToBeSent.concat(argFile);
    this.setState({filesToBeSent: joined})
  }

  deleteFile(argFile) {
    const results = this.state.results
    var Promise = this.Promise || require('promise');
    const request = require('superagent-promise')(require('superagent'), Promise);
    const req = request.post(window.globalAppTrackURL + "DeleteFile/" + results[0]["LP_NUMBER"])
    req.attach("file", argFile)
    req.end()
      .then(function(res)  {return(res)})
      .catch(function(err) {return(err)})

      .then((json) => this.finishDelete(argFile, json))
  }

  finishDelete(argFile, res) {

  }

  /********************************/
  /* Get Document ID              */
  /********************************/

  /***** Renderer ****/
  renderDOFStep1() {
    var tblRow
    var res = this.state.results;

    function formatErrorString(acrisError) {
      //http://gis.nyc.gov/taxmap/map.htm?searchType=BblSearch&featureTypeName=EVERY_BBL&borough=Brooklyn&block=196&lot=63
      //http://gis.nyc.gov/taxmap/history.htm?search={"declaredClass":"Sea","parameters":{"searchType":"boroBlockLot","inBorough":"1","inBlock":"463", "inLot":"34"}}
      if(acrisError) {
        if (acrisError.indexOf("Please enter the NYC.ID Email id for Login") > 0 ||
            acrisError.indexOf("User has not been authenticated") > 0)
          return "Invalid user credentials. Please try with valid credentials."
        else
          if (acrisError.indexOf("Error while validating document") >0) {
          var A_Errors = acrisError.substring(acrisError.indexOf("Error while validating document")).split(',');
          var errString = "Following properties returned an error.\n\n"
          var i = 0
          do {
            const itemNo = parseInt(A_Errors[i].substring(A_Errors[i].indexOf("item") + 5))
            if (itemNo)
              errString = errString + "Item " + itemNo +
                " - " + "BBL: " + res[itemNo - 1]["BUILDING_BBL"] + " " + res[itemNo - 1]["DESIG_ADDRESS"] +
                " - " + A_Errors[i + 1].substring(0, A_Errors[i + 1].indexOf(")") + 1) +
                "\n"
            i = i + 2;
          } while (i < A_Errors.length)
          return errString
        }
        else
            return "System Error. Contact your administrator.\n\n" + acrisError;
      }
      else
        return ""
    }

    var formattedError = formatErrorString(this.state.acrisError)

    if (this.state.acrisDocument) {
      tblRow =
        <Table.Row>
          <Table.Cell>{this.state.acrisDocument.documentID}</Table.Cell>
          <Table.Cell>{this.state.acrisDocument.transactionNumber}</Table.Cell>
          <Table.Cell>{this.state.acrisDocument.status}</Table.Cell>
        </Table.Row>
    } else if (this.state.acrisError) {
      tblRow =
        <Table.Row><Table.Cell colSpan="3">

          <p style={{"color" :"white", backgroundColor: "red"}}>
            <b>Unable to submit designation. See technical details below.</b>
            <br /><br />
            <div>{formattedError.split("\n").map((i,key) => {
              return <div key={key}>{i}</div>;
            })}</div>
          </p>

        </Table.Cell></Table.Row>
    } else {
      tblRow =
        <Table.Row><Table.Cell colSpan="3">
          <Loader active inline='centered'/>
        </Table.Cell></Table.Row>
    }

    return (
      <div>
        <div className="properties-list">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>DocumentID</Table.HeaderCell>
                <Table.HeaderCell>Transaction Number</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {tblRow}
            </Table.Body>
          </Table>
        </div>
      </div>
    )
  }

  /***** Data Handlers *****/
  createDocumentID() {
    //const request = require('request');
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User" : this.state.User,
        "createdate": this.state.createDate,
        "lpNumber": this.state.results[0]["LP_NUMBER"],
        "lmName" : this.state.results[0]["LM_NAME"],
        "lmType" : this.state.results[0]["LM_TYPE"],
        "properties": this.state.results,
        "documents": this.state.filesToBeSent
      }
    }
    rp({
        url: window.globalAppTrackURL + "CreateCoverPage",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

    .then((json) => this.finishUpdateAcrisDocId(json))
  }

  finishUpdateAcrisDocId(res) {
    var errVal, docVal
    if(res.error) {
      errVal = res.toString()
      //errVal = (res.message).substr((res.message).indexOf("Errors"))
      docVal = null
    } else {
      errVal = null
      docVal = {
        transactionNumber: res.TransactionID,
        documentID: res.DocumentID,
        status: res.Message + " (Not Submitted)"
      }
    }
    this.setState({acrisError: errVal, acrisDocument: docVal})
  }

  /********************************/
  /* Submission PDF Preview       */
  /********************************/

  /***** Renderer ****/
  renderDOFStep2() {
    const fUrl = window.fileServerURL
    const fName = this.state.results[0]["LP_NUMBER"] + "-" + this.state.acrisDocument.documentID + ".pdf"
    var docPlaceholder
    if (this.state.dispReady)
      docPlaceholder = <Embed icon='right circle arrow' defaultActive url={fUrl + fName} />
    else
      docPlaceholder = <Loader active inline='centered'/>
    return (
      <div>
        <div className="properties-list">
          {docPlaceholder}
        </div>
      </div>
    )
  }

  /***** Data Handlers *****/
  uploadDocumentsToAcris() {
    this.setState({dispReady: false})
    const documents = this.state.filesToBeSent.map(function (aDocument) {
      return({"name" : aDocument.name})
    })
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": this.state.User,
        "lpNumber": this.state.results[0]["LP_NUMBER"],
        "documentid": this.state.acrisDocument.documentID,
        "documents": JSON.stringify(documents)
      }
    }
    rp({
        url: window.globalAppTrackURL + "UploadDocuments",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

      .then((json) => this.finishUploadingDocs(json))
  }

  finishUploadingDocs(res) {
    //download PDF
    this.downloadPDFfromAcris()
  }

  downloadPDFfromAcris() {
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": this.state.User,
        "lpNumber": this.state.results[0]["LP_NUMBER"],
        "documentid": this.state.acrisDocument.documentID,
      }
    }
    rp({
        url: window.globalAppTrackURL + "DownloadPDF",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

    .then((json) => this.finishDownload(json))
  }

  finishDownload(res) {
    // "DocumentID": args.documentID,
    //   "Message": "Download Success",
    //   "CPfile" : fileName

    this.setState({dispReady: true})
  }

  /********************************/
  /* Submission Complete          */
  /********************************/

  /***** Renderer ****/
  renderDOFStep3() {
    const url = window.fileServerURL
    const fName = this.state.results[0]["LP_NUMBER"] + "-" + this.state.acrisDocument.documentID + ".pdf"

    return (
      <div>
        <div className="properties-list">
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Document ID</Table.HeaderCell>
                <Table.HeaderCell>Transaction ID</Table.HeaderCell>
                <Table.HeaderCell>Submission Date</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              <Table.Row>
                <Table.Cell><a href={url+fName}
                               target="blank">{this.state.acrisDocument.documentID}</a></Table.Cell>
                <Table.Cell>{this.state.acrisDocument.transactionNumber}</Table.Cell>
                <Table.Cell>{this.state.submissionComplete}</Table.Cell>
                <Table.Cell>SUBMITTED (not recorded yet)</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
    )
  }

  /***** Data Handlers *****/
  submitToAcris() {
    var rp = require('request-promise');
    const requestData = {
      request: {
        "User": this.state.User,
        "createdate": this.state.todaysDate,
        "lpNumber": this.state.results[0]["LP_NUMBER"],
        "documentid": this.state.acrisDocument.documentID,
        "transactionid": this.state.acrisDocument.transactionNumber
      }
    }
    rp({
        url: window.globalAppTrackURL + "FinalSubmit",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

    .then((json) => this.finishSubmission(requestData, json))
  }

  finishSubmission(requestData, res) {
    this.setState({submissionComplete: res.SubmissionDate})
    this.updateDatabase(res)
  }

  updateDatabase(res) {
    var rp = require('request-promise');
    const requestData = {
      request: {
        "transactionid": this.state.acrisDocument.transactionNumber,
        "documentid": this.state.acrisDocument.documentID,
        "lpNumber": this.state.results[0]["LP_NUMBER"],
        "createdate": this.state.todaysDate,
        "submissiondate": res.SubmissionDate,
        "User": this.props.User,
        "numpages": this.state.filesToBeSent[0].numpages,
        "status": 1,
        "properties": this.state.results
      }
    }
    rp({
        url: window.globalAppTrackURL + "UpdateDatabase",
        method: "POST",
        headers: {"content-type": "application/json"},
        json: true,
        body: requestData
      }
    )
      .then(function (res) {return res})
      .catch(function (err) {return(err)})

    .then((json) => this.finishUpdate(json))
  }

  finishUpdate(json) {

  }

  zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }

  zeroFill(number, size) {
    number = number.toString();
    while (number.length < size) number = "0" + number;
    return number;
  }

}

export default Designation



// WEBPACK FOOTER //
// ./src/components/Designation.js